import { defineComponent as _defineComponent } from 'vue'

import ActivityLogItemIcon from './ActivityLogItemIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityLogItem',
  props: {
    formattedChange: null
  },
  setup(__props: any) {

const props = __props as {
  formattedChange: any
}



const fieldKey = (field) =>
  `${field.columnName}-${field.originalValue}-${field.newValue}`

return { __sfc: true,props, fieldKey, ActivityLogItemIcon }
}

})